import { HSLColor } from '@yola/yola-palette-generator';
import findColorShadeInPalette from './find-color-shade-in-palette';
import emitFallbackWarning from './emit-fallback-warning';
import findSmallestShade from './find-smallest-shade';
import findBiggestShade from './find-biggest-shade';

const changeColorPointByStep = ({ targetColor, targetColorPalette, step, fallback }, isReduce) => {
  const { hue, saturation, lightness, alpha } = targetColor;
  const colorInstance = new HSLColor(hue, saturation, lightness, alpha);

  const colorShade = findColorShadeInPalette(colorInstance, targetColorPalette);
  const shades = Object.keys(targetColorPalette);

  if (isReduce) {
    shades.reverse();
  }

  const shadeInArray = shades.indexOf(colorShade);

  const newPosition = shadeInArray + step;

  if (newPosition > shades.length - 1) {
    emitFallbackWarning(
      `Can't ${
        isReduce ? 'reduce' : 'increase'
      } hsl(${targetColor.toColorString()}) color point from ${colorShade} by ${step}.`,
      fallback
    );
    const fallbackShade = isReduce
      ? findSmallestShade(targetColorPalette)
      : findBiggestShade(targetColorPalette);
    return targetColorPalette[fallbackShade];
  }

  const newColorShade = shades[newPosition];

  return targetColorPalette[newColorShade];
};

export default changeColorPointByStep;
